module.exports = "/static/assets/51129746f637c83656246221e5a5a10c.png";